// extracted by mini-css-extract-plugin
module.exports = {"policy-summary-mobile":"policy-summary-mobile_policy-summary-mobile__2MNXT","title":"policy-summary-mobile_title__17Mqg","policies":"policy-summary-mobile_policies__1ox3Y"};